import React, { useState, useEffect } from 'react';
/* Helpers */
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { goodsListMock } from '../../../helpers/mocks/goodsList';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentSimulationThunk } from '../../../redux/actions/index';

export const LoanCategorySelector = ({ title }) => {
  const { index } = useSelector(state => state.currentSimulation.purpose);
  const dispatch = useDispatch();
  const setCurrentSimulation = (currentSimulationData) => dispatch(setCurrentSimulationThunk(currentSimulationData));
  const [ optionsList, setOptionsList ] = useState('');

  const updateOptions = function(optionsList) {
    const selectElement = window.$('.selectpicker');
    let options;

    selectElement.html(optionsList);
    options = document.querySelectorAll('.selectpicker option');

    options.forEach(function(option, index) {
      const dataIcon = option.getAttribute('data-icon');
      const value = option.value;

      option.setAttribute('data-icon', `glyphicon ${dataIcon}`);
      option.setAttribute('data-code', value);
      option.setAttribute('value', index);
    });

    selectElement.selectpicker('refresh');
    selectElement.selectpicker('val', index);
  }
  
  const getGoodsList = () => {
    const callbacks = {
      200: function(response) {
        updateOptions(response.data);
      },
      400: function() {
        console.warn('GoodsList loading error');
      },
      404: function() {
        if (window.location.hostname === 'localhost') {
          const goodsList = goodsListMock;
          
          updateOptions(goodsList);
        } else {
          console.warn('GoodsList loading error');
        }
      },
      500: function() {
        console.warn('GoodsList loading error');
      },
      default: function() {
        console.warn('GoodsList loading error');
      },
    };
    
    handleAPIRequest({
      method: 'GET',
      url: getPartnerEndpoints("compass").api.goodsList,
    }, callbacks);
  }
  
  useEffect(function() {
    getGoodsList();
  }, []);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;

    const optionsList = document.querySelectorAll('select[name="purpose"] option');
    const selectedOption = optionsList[parseInt(value) + 1];
    const selectedOptionText = selectedOption.textContent;
    const selectedOptionIcon = selectedOption.dataset.icon.split(" ")[1];
    const selectedOptionCode = selectedOption.dataset.code;

    setCurrentSimulation({
      purpose: {
        index: value.toString(),
        icon: selectedOptionIcon,
        text: selectedOptionText,
        code: selectedOptionCode,
      }
    });
  }

  return (
    <div className="loan-dropdown-scp">
      <div className="loan-title-scp">{ title }</div>
      <div className="load-select-scp form-item">
        <select className="selectpicker option-group" name="purpose" title="Scegli il tuo obiettivo" onChange={event => handleChange(event)} required="required"></select>
      </div>
    </div>
  );
}
